var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"navbox"}},[_c('div',{staticClass:"slotContainer"},[_vm._t("default")],2),_vm._t("noStyling")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }